import isEqual from 'lodash/isEqual'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import { templatesSelectModalSelector } from 'store/modals'
import {
  toFormikChecklists,
  stripPositionId,
} from 'ui/components/checklist/ChecklistForm/helpers'
import ConfirmModal from 'ui/components/modals/ConfirmModal'
import ModalBasic from 'ui/components/modals/ModalBasic'
import TemplatesSelectItem from './components/TemplatesSelectItem'
import { TemplatesSelectStyled } from './styled'

const LEXICAL_EMPTY_PARAGRAPH_HTML = '<p class="editor-paragraph"><br></p>'

const TemplatesSelectModal = ({
  descriptionValue,
  checklistsValue,
  appliedTemplate,
  applyDescriptionTemplate,
  open,
  handlerClose,
}) => {
  const [expandedIds, setExpandedIds] = useState([])
  const [confirmOpen, setConfirmOpen] = useState(false)
  const [pendingContent, setPendingContent] = useState(null)

  const { title, templates } = useSelector(templatesSelectModalSelector)

  const closeModal = () => {
    setExpandedIds([])
    handlerClose()
  }

  const closeConfirm = () => {
    setConfirmOpen(false)
    setPendingContent(null)
  }

  const apply = ({ description, preparedChecklists }) => {
    applyDescriptionTemplate({ description, preparedChecklists })
    closeModal()
  }

  const handleApplyClick = ({ description, checklists }) => {
    const preparedChecklists = toFormikChecklists(checklists)
    const normalizedChecklistsValue = stripPositionId(checklistsValue)

    const isEmpty = descriptionValue === LEXICAL_EMPTY_PARAGRAPH_HTML
    const isSameTemplate =
      descriptionValue === description &&
      isEqual(normalizedChecklistsValue, stripPositionId(preparedChecklists))

    const hasAppliedTemplate = !!appliedTemplate

    const descriptionWasEdited =
      hasAppliedTemplate && descriptionValue !== appliedTemplate.description

    const checklistsWereEdited =
      hasAppliedTemplate &&
      !isEqual(
        normalizedChecklistsValue,
        stripPositionId(appliedTemplate?.checklists ?? [])
      )

    const templateWasEdited = descriptionWasEdited || checklistsWereEdited

    const shouldWarn =
      !isEmpty && !isSameTemplate && (!hasAppliedTemplate || templateWasEdited)

    if (shouldWarn) {
      setPendingContent({
        description,
        preparedChecklists,
      })
      setConfirmOpen(true)
      return
    }

    apply({ description, preparedChecklists })
  }

  return (
    <>
      <ModalBasic
        open={open}
        size="templatesSelect"
        handlerClose={closeModal}
        title={title}
      >
        <TemplatesSelectStyled>
          {templates?.length > 0 &&
            templates.map(({ id, name, task_type, content, checklists }) => {
              const isExpanded = expandedIds.includes(id)

              return (
                <TemplatesSelectItem
                  key={id}
                  id={id}
                  name={name}
                  taskType={task_type}
                  content={content}
                  checklists={checklists}
                  expanded={isExpanded}
                  onToggle={(id, next) => {
                    setExpandedIds((prev) =>
                      next
                        ? [...prev, id]
                        : prev.filter((expandedId) => expandedId !== id)
                    )
                  }}
                  onApply={() =>
                    handleApplyClick({ description: content, checklists })
                  }
                />
              )
            })}
        </TemplatesSelectStyled>
      </ModalBasic>

      <ConfirmModal
        title="Заменить данные?"
        text="Текущее описание будет удалено и заменено новым шаблоном. Продолжить?"
        open={confirmOpen}
        confirmHandler={() => {
          apply(pendingContent)
          closeConfirm()
        }}
        handlerClose={() => closeConfirm()}
        confirmText="Заменить"
        cancelText="Отменить"
      />
    </>
  )
}

export default TemplatesSelectModal
